import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class HotelAccountSelectionController extends Controller {
  queryParams = ['redirectTo'];
  @service declare navigation: Services['navigation'];
  @service declare router: Services['router'];

  @tracked redirectTo: string | null = null;

  get isSettingsContext(): boolean {
    return this.redirectTo?.startsWith('hotel.settings.') ?? false;
  }

  @action
  handleContinue(subscriptionId: string): void {
    const route = this.redirectTo ?? 'hotel.overview';
    const queryParams =
      this.navigation.accountSelectionRedirectQueryParams ?? {};

    this.navigation.accountSelectionRedirectTo = route;
    this.navigation.accountSelectionConfirmed = true;
    void this.router.transitionTo(route, subscriptionId, { queryParams });
  }
}
